<template>
  <div>
    <base-loading v-if="!ready" />
    <v-container
      v-else
      :style="$vuetify.breakpoint.lgAndDown ? 'width: 100%;' : 'width: 75%;'"
      fluid
    />
  </div>
</template>

<script>

  export default {
    name: 'DashboardProdutor',

    data () {
      return {
        dialog: false,
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>

<style lang="scss">

</style>
